import { getUriParams } from '../../../helpers/utils/utils';
import { CORE, gateway } from '../../api';

export function findAllRecalculosProcessoService(idProcesso, pageable) {
  const queryParams = getUriParams(pageable);
  return gateway.get(`${CORE}/processos/${idProcesso}/recalculo?${queryParams}`);
}
